import { normalizeOwnedReferral } from './ownedReferral';

// Keep the first paid visit intact through authentication and internal links.
export const ACQUISITION_KEY = 'indiefy-acquisition-v1';
const MAX_AGE = 90 * 24 * 60 * 60 * 1000;
const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid'];
const clickFields = ['gclid', 'gbraid', 'wbraid'];
const hasControl = text => [...text].some(character => character.charCodeAt(0) < 32);

function clean(value, click = false) {
  if (typeof value !== 'string') return '';
  const text = value.trim();
  if (!text || text === 'undefined' || text === 'null' || text.length > (click ? 512 : 200)
    || hasControl(text) || /[<>]/.test(text) || (click && !/^[A-Za-z0-9._~-]+$/.test(text))) return '';
  return text;
}

export function isPaidAcquisition(data) {
  return clickFields.some(key => data[key]) || /^(cpc|ppc|paid|paid_search|paid_social)$/i.test(data.utm_medium || '');
}

export function getAcquisition(now = Date.now()) {
  try {
    const stored = JSON.parse(localStorage.getItem(ACQUISITION_KEY) || 'null');
    if (!stored || !Number.isFinite(stored.capturedAt) || now < stored.capturedAt || now - stored.capturedAt > MAX_AGE) return {};
    return normalizeOwnedReferral(Object.fromEntries(fields.map(key => [key, clean(stored[key], clickFields.includes(key))]).filter(([, value]) => value)));
  } catch { return {}; }
}

export function captureAcquisition(query = {}, now = Date.now()) {
  const incoming = normalizeOwnedReferral(Object.fromEntries(fields.map(key => [key, clean(query[key], clickFields.includes(key))]).filter(([, value]) => value)));
  const previous = getAcquisition(now);
  if (!Object.keys(incoming).length || isPaidAcquisition(previous)) return previous;
  const chosen = isPaidAcquisition(incoming) || !Object.keys(previous).length ? incoming : previous;
  try { localStorage.setItem(ACQUISITION_KEY, JSON.stringify({ ...chosen, capturedAt: now })); } catch { /* Storage may be disabled. */ }
  return chosen;
}

export function acquisitionPayload() {
  const data = getAcquisition();
  // Read old storage once so visits captured before this release remain usable.
  if (!Object.keys(data).length) {
    try { if (localStorage.getItem(ACQUISITION_KEY)) return {}; } catch { return {}; }
    try { for (const key of fields) { const value = clean(localStorage.getItem(key), clickFields.includes(key)); if (value) data[key] = value; } } catch { /* Optional attribution. */ }
    if (Object.keys(data).length) captureAcquisition(data);
  }
  return data;
}

const sentInMemory = new Set();
export function trackRegistration(user, method) {
  if (user?.first_time !== true || !user._id || typeof window.gtag !== 'function') return false;
  const eventId = user.registration_event_id || `registration_${user._id}`;
  const key = `indiefy-signup-sent:${eventId}`;
  if (sentInMemory.has(eventId)) return false;
  try { if (localStorage.getItem(key)) return false; } catch { /* Memory guard still applies. */ }
  try { window.gtag('event', 'sign_up', { method, event_id: eventId }); }
  catch { return false; }
  sentInMemory.add(eventId);
  try { localStorage.setItem(key, '1'); } catch { /* Never block signup. */ }
  return true;
}

export function internalAuthDestination(value, fallback = '/dashboard') {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\') || hasControl(value)) return fallback;
  return value;
}
